module.exports = __webpack_public_path__ + "8c35bf54c505d32035cafd344d316bb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000WKJ.png
// module id = 1641
// module chunks = 0